{
  "schema": 1,
  "roughness": 0.07,
  "diffuseScatter": 0.08,
  "reflectionStrength": 0.9,
  "fresnel0": 0.0387252,
  "reflectionMip": 1.2,
  "maxReflectance": 0.22,
  "preserveOpacity": true,
  "referenceIor": 1.49,
  "cutEdge": {
    "roughness": 0.06,
    "diffuseScatter": 0.38,
    "reflectionStrength": 1,
    "maxReflectance": 0.42
  }
}
